import { GatsbyImage } from 'gatsby-plugin-image'
import { StaticQuery, graphql } from 'gatsby'

export const Image = ({
  filename,
  alt,
  ...rest
}: {
  filename: string
  alt: string
  className?: string
  height?: number
}) => {
  return (
    <StaticQuery
      query={graphql`
        query {
          images: allFile(filter: { extension: { ne: "svg" } }) {
            edges {
              node {
                relativePath
                name
                childImageSharp {
                  gatsbyImageData(layout: FULL_WIDTH)
                }
              }
            }
          }
        }
      `}
      render={(data: any): JSX.Element | null => {
        const image = data.images.edges.find((n: any) => {
          return n.node.relativePath.includes(filename)
        })
        if (!image) {
          return null
        }

        return (
          <GatsbyImage
            alt={alt}
            image={image.node.childImageSharp.gatsbyImageData}
            {...rest}
          />
        )
      }}
    />
  )
}
